import Heading from 'components/Basic/Heading/Heading';
import { ProductItemSkeleton } from 'components/Blocks/Product/List/ListedItem/ProductItemSkeleton';
import ProductsList, { ProductListTypes } from 'components/Blocks/Product/List/ProductsList';
import Webline from 'components/Layout/Webline/Webline';
import { createEmptyArray } from 'helpers/arrayUtils';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { useSharedWishlist } from 'hooks/wishlist/useWishlist';

type SharedWishlistProps = {
    urlQueryParamId: string;
};

export const SharedWishlist: FC<SharedWishlistProps> = ({ urlQueryParamId }) => {
    const t = useTypedTranslationFunction();
    const { products, fetching } = useSharedWishlist(urlQueryParamId.split(','));

    if (fetching) {
        return (
            <Webline>
                {createEmptyArray(6).map((_, index) => (
                    <ProductItemSkeleton key={index} />
                ))}
            </Webline>
        );
    }

    return (
        <Webline>
            {products.length > 0 ? (
                <>
                    <div className="mb-7 flex flex-wrap">
                        <div className="mb-4 flex w-full items-end vl:mb-0 vl:flex-1">
                            <div className="flex-1 vl:flex-none">
                                <Heading type="h1" className="!mb-0 !leading-7">
                                    {t('Shared wishlist')}
                                </Heading>
                            </div>
                        </div>
                    </div>

                    <ProductsList
                        products={products}
                        isLoading={fetching}
                        gtmListName="sharedWishlist"
                        type={ProductListTypes.Normal}
                    />
                </>
            ) : (
                <div className="my-[50px]">
                    <Heading type="h3">{t('There are no products in the shared wishlist.')}</Heading>
                </div>
            )}
        </Webline>
    );
};

export default SharedWishlist;
